export const isTestCopy = () => window.location.hostname.includes("preview.");

export const EnvBanner = () => {
  if (!isTestCopy()) return null;
  return (
    <div data-testid="env-test-banner" className="bg-[#E05C3A] px-4 py-2 text-center text-xs font-bold text-white">
      TEST COPY: data here is separate. Changes here do not affect the live app at app.kindsaver.com
    </div>
  );
};
